<template>
  <el-dropdown @command="changeTheme">
    <span class="icon iconfont" style="font-size: 22px;color: white">&#xe721;</span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item class="clearfix" command="black">
        黑色
      </el-dropdown-item>
      <el-dropdown-item class="clearfix" command="blue">
        深蓝色
      </el-dropdown-item>
      <el-dropdown-item class="clearfix" command="blackish_green">
        墨绿色
      </el-dropdown-item>
      <el-dropdown-item class="clearfix" command="light_blue">
        浅蓝色
      </el-dropdown-item>
      <el-dropdown-item class="clearfix" command="sky_blue">
        混合色1
      </el-dropdown-item>
      <el-dropdown-item class="clearfix" command="min">
        混合色2
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>

  export default {
    methods: {
      // change theme - 换肤
      changeTheme(command) {
        //navbar自定义样式
        localStorage.setItem("navbarColors",command)
        this.$store.commit('common/updateNavbarLayoutType', localStorage.getItem("navbarColors"))
        //侧边栏自定义样式
        if((command == 'sky_blue') || (command == 'blue') || (command == 'blackish_green')){
          localStorage.setItem("sidebarColors",command)
          this.$store.commit('common/updateSidebarLayoutSkin', localStorage.getItem("sidebarColors"))
        }else{
          //侧边栏为黑色样式
          localStorage.setItem("sidebarColors",'black')
          this.$store.commit('common/updateSidebarLayoutSkin', localStorage.getItem("sidebarColors"))
        }
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/theme/index.vue